import React, { useState } from "react";
import "../Styles/Login.css";

import {
  Eye,
  EyeOff,
  LockKeyhole,
  ShieldCheck,
  Building2,
  ChevronRight,
  
} from "lucide-react";

import { toast } from "react-toastify";

import rcsLogo from "../assets/rcslogo.png";

const Login = ({ onLogin }) => {

  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] =
    useState(false);

  const [rememberMe, setRememberMe] =
    useState(false);

  const [capsLock, setCapsLock] =
    useState(false);


const [showRecovery, setShowRecovery] =
  useState(false);

const [securityAnswers, setSecurityAnswers] =
  useState({
    color: "",
    hobby: "",
  });



  const handleSubmit = (e) => {

    e.preventDefault();

    if (!password) {

      toast.warning(
        "Please enter your password."
      );

      return;
    }

    if (password === "Rcsadmin@1") {

      const storage =
        rememberMe
          ? localStorage
          : sessionStorage;

      storage.setItem(
        "authenticated",
        "true"
      );

      toast.success(
        "Access Granted"
      );

      onLogin();

    } else {

      toast.error(
        "Incorrect password."
      );
    }
  };

  const handleKeyDown = (e) => {

    setCapsLock(
      e.getModifierState("CapsLock")
    );

    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };



  const handleRecovery = () => {

  const color =
    securityAnswers.color
      .trim()
      .toLowerCase();

  const hobby =
    securityAnswers.hobby
      .trim()
      .toLowerCase();

  if (
    color === "yellow" &&
    hobby === "sleep"
  ) {

    toast.success(
      "Recovery Successful"
    );

    toast.info(
      "Admin Password: Rcsadmin@1",
      {
        autoClose: 10000,
      }
    );

    setShowRecovery(false);

  } else {

    toast.error(
      "Security answers incorrect."
    );
  }
};

  return (

    <div className="modern-login-page">

      {/* ========================= */}
      {/* BACKGROUND GLOW */}
      {/* ========================= */}

      <div className="login-bg-glow login-bg-glow-1" />
      <div className="login-bg-glow login-bg-glow-2" />

      {/* ========================= */}
      {/* LOGIN CONTAINER */}
      {/* ========================= */}

      <div className="modern-login-container">

        {/* ========================= */}
        {/* LEFT PANEL */}
        {/* ========================= */}

        <div className="modern-login-left">

          <div className="login-left-overlay" />

          <div className="login-brand">

            <img
              src={rcsLogo}
              alt="RCS"
              className="modern-login-logo"
            />

            <h1>
              RCS Admin Console
            </h1>

            <p>
              Unified operations,
              financial oversight,
              and admin control.
            </p>

          </div>

          <div className="login-left-content">

            <div className="login-feature">

              <ShieldCheck size={18} />

              <div>

                <h4>
                  Secure Access
                </h4>

                <span>
                  Caution!- The information contain within are meant only for its intended users
                </span>

              </div>

            </div>

            <div className="login-feature">

              <Building2 size={18} />

              <div>

                <h4>
                  Unified Platform
                </h4>

                <span>
                  Manage accounts,
                  loans, MMG,
                  reports and more
                </span>

              </div>

            </div>

          </div>

          <div className="login-left-footer">

            Protected by RCS
            Authentication Pass- Contact Admin for Credentials

          </div>

        </div>

        {/* ========================= */}
        {/* RIGHT PANEL */}
        {/* ========================= */}

        <div className="modern-login-right">

          <div className="login-form-wrapper">

            <div className="login-badge">

              <ShieldCheck size={14} />

              Admin Access

            </div>

            <h2>
              Welcome Back 👋
            </h2>

            <p className="login-subtext">
              Sign in to continue
              to the RCS Admin Console
            </p>

            <form
              onSubmit={handleSubmit}
              className="modern-login-form"
            >

              {/* ========================= */}
              {/* PASSWORD INPUT */}
              {/* ========================= */}

              <div className="modern-input-group">

                <div className="modern-input-icon">

                  <LockKeyhole size={18} />

                </div>

                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) =>
                    setPassword(
                      e.target.value
                    )
                  }
                  onKeyDown={
                    handleKeyDown
                  }
                  autoFocus
                />

                <button
                  type="button"
                  className="password-toggle"
                  onClick={() =>
                    setShowPassword(
                      !showPassword
                    )
                  }
                >

                  {showPassword ? (
                    <EyeOff size={18} />
                  ) : (
                    <Eye size={18} />
                  )}

                </button>

              </div>

              {/* ========================= */}
              {/* CAPS WARNING */}
              {/* ========================= */}

              {capsLock && (

                <div className="caps-warning-modern">

                  ⚠ Caps Lock is ON

                </div>

              )}

              {/* ========================= */}
              {/* OPTIONS */}
              {/* ========================= */}

              <div className="login-options">

                <label className="remember-modern">

                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={() =>
                      setRememberMe(
                        !rememberMe
                      )
                    }
                  />

                  <span>
                    Remember me
                  </span>

                </label>
<button
  type="button"
  className="forgot-btn"
  onClick={() =>
    setShowRecovery(true)
  }
>

  Forgot password?

</button>

              </div>

              {/* ========================= */}
              {/* LOGIN BUTTON */}
              {/* ========================= */}

              <button
                type="submit"
                className="modern-login-btn"
              >

                <span>
                  Sign In
                </span>

                <ChevronRight
                  size={18}
                />

              </button>

            </form>

            {/* ========================= */}
            {/* FOOTER */}
            {/* ========================= */}

{showRecovery && (

  <div className="recovery-overlay">

    <div className="recovery-modal">

      <div className="recovery-header">

        <h3>
          Security Verification
        </h3>

        <p>
          Hey Stupid!
          Stop forgetting your passwords.
          Fill out the answers below
          to reveal password.
        </p>

      </div>

      <div className="recovery-body">

        <div className="recovery-field">

          <label>
            Favourite Color
          </label>

          <input
            type="text"
            placeholder="Enter answer"
            value={
              securityAnswers.color
            }
            onChange={(e) =>
              setSecurityAnswers({
                ...securityAnswers,
                color:
                  e.target.value,
              })
            }
          />

        </div>

        <div className="recovery-field">

          <label>
            Favourite Hobby
          </label>

          <input
            type="text"
            placeholder="Enter answer"
            value={
              securityAnswers.hobby
            }
            onChange={(e) =>
              setSecurityAnswers({
                ...securityAnswers,
                hobby:
                  e.target.value,
              })
            }
          />

        </div>

      </div>

      <div className="recovery-actions">

        <button
          className="recovery-cancel"
          onClick={() =>
            setShowRecovery(false)
          }
        >

          Cancel

        </button>

        <button
          className="recovery-submit"
          onClick={handleRecovery}
        >

          Verify

        </button>

      </div>

    </div>

  </div>

)}


            <div className="modern-login-footer">

              © {new Date().getFullYear()}
              {" "}
              RCS Top-Up & Billing Entity.
              <br />
              All rights reserved.

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Login;